// Brand & contact data — Altez Palarin Estudio Contable
export const BRAND = {
    name: "Altez Palarin",
    fullName: "Estela Altez Palarin",
    tagline: "Estudio Contable",
    role: "Contadora Pública · CRA Uruguay",
    phoneDisplay: "+598 98 540 987",
    whatsappDisplay: "+598 98 540 987",
    // wa.me requires digits only with country code
    whatsappNumber: "59898540987",
    email: "contadoraaltezpalarin@gmail.com",
    instagram: "@estudiocontablealtezpalarin",
    instagramUrl: "https://www.instagram.com/estudiocontablealtezpalarin/",
    sedes: [
        {
            city: "Rocha",
            address: "Leonardo Olivera 174",
            region: "Rocha, Uruguay",
        },
        {
            city: "Castillos",
            address: "Ferrer 1368",
            region: "Castillos, Rocha",
        },
    ],
    developer: "UMA Agency",
    developerUrl: "https://umaagency.com",
};

export const UMA = BRAND;

export function buildWhatsappUrl(message) {
    const base = `https://wa.me/${BRAND.whatsappNumber}`;
    if (!message) return base;
    return `${base}?text=${encodeURIComponent(message)}`;
}

export function openWhatsapp(message) {
    const url = buildWhatsappUrl(
        message ||
            "Hola Estela, vengo del sitio. Me gustaría coordinar una consulta.",
    );
    window.open(url, "_blank", "noopener,noreferrer");
}

export function openAgendar(extra) {
    const message =
        extra ||
        "Hola Estela, quisiera agendar una cita para una consulta. ¿Cuándo tendrías disponibilidad?";
    openWhatsapp(message);
}

export function buildMailto({ name, whatsapp, service, message }) {
    const subject = `Nueva consulta — ${name || "Sin nombre"}`;
    const body = [
        `Nombre: ${name || "-"}`,
        `WhatsApp: ${whatsapp || "-"}`,
        `Servicio de interés: ${service || "-"}`,
        "",
        "Mensaje:",
        message || "-",
    ].join("\n");
    return `mailto:${BRAND.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function submitContact(form) {
    const text = [
        `*Solicito agendar una cita — Estudio Altez Palarin*`,
        ``,
        `*Nombre:* ${form.name || "-"}`,
        `*WhatsApp:* ${form.whatsapp || "-"}`,
        `*Servicio:* ${form.service || "-"}`,
        ``,
        `*Mensaje:*`,
        `${form.message || "-"}`,
    ].join("\n");
    openWhatsapp(text);
}
